import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e99b42f6")

_pushScopeId("data-v-e99b42f6")
const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "grid w-full h-full grid-cols-2 gap-8" }
const _hoisted_3 = { class: "grid h-full grid-flow-row grid-cols-1 grid-rows-3 gap-8 p-8 pr-4" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  key: 0,
  class: "fixed top-0 bottom-0 right-0 z-50 w-1/2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_student_phase_progression_card = _resolveComponent("student-phase-progression-card")
  const _component_student_overall_progression = _resolveComponent("student-overall-progression")
  const _component_student_phase_progress_overview = _resolveComponent("student-phase-progress-overview")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventPhases, (eventPhase, index) => {
          return (_openBlock(), _createBlock(_component_student_phase_progression_card, {
            key: index,
            isActive: _ctx.activeChapterPhase === eventPhase,
            student: _ctx.student,
            phase: eventPhase.phase,
            onClick: ($event: any) => (_ctx.handlePhaseClick(eventPhase))
          }, null, 8, ["isActive", "student", "phase", "onClick"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_student_overall_progression, { percentComplete: _ctx.progress }, null, 8, ["percentComplete"])
      ]),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withId(() => [
          (_ctx.route.query.phase)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_student_phase_progress_overview, {
                  class: "overflow-y-auto border-l",
                  student: _ctx.student,
                  phaseEvents: _ctx.activeChapterPhase.events,
                  studentEvents: _ctx.studentEvents,
                  unlockedEvents: _ctx.unlockedEvents,
                  phase: _ctx.activeChapterPhase.phase,
                  onClose: _ctx.handleClosePhaseOverview,
                  onSelectEvent: _ctx.handleEventSelection
                }, null, 8, ["student", "phaseEvents", "studentEvents", "unlockedEvents", "phase", "onClose", "onSelectEvent"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
})